/**
 * usage: this.$util.upload(图片source, 图片名字).then(ret => {
 *  ret: 图片key(传给后台)
 * })
 */
interface Alioss {
  host: any;
  signature: any;
  policy: any;
  accessid: any;
}

// 图片上传阿里云OSS
import axios, { AxiosResponse } from 'axios';

// 获取policy
export const upload = (file: any, name: string) => {
  return new Promise((resolve, reject) => {
    axios.get('/api/System/OSSSignature').then((res: any) => {
      const { host, signature, policy, accessid } = res
      let params = new FormData(), key = calculate_object_name(name, 'ams_admin/')
      // 添加签名信息
      params.append('OSSAccessKeyId', accessid)
      params.append('policy', policy)
      params.append('Signature', signature)
      params.append('key', key)
      params.append('success_action_status', '200')
      // 添加文件
      params.append('file', file, name)

      axios.post(host, params).then(() => {
        resolve(key)
      }).catch(() => {
        resolve(key)
      })
    }).catch((err: any) => {
      reject(err)
    })
  })
}

function calculate_object_name(filename: string, dir = '')
{
    let suffix = get_suffix(filename)
    dir = dir || ''
    return dir + random_string(10) + suffix
}

function get_suffix(filename: string) {
  let pos = filename.lastIndexOf('.'), suffix = ''
  if (pos != -1) {
      suffix = filename.substring(pos)
  }
  return suffix
}

function random_string(len: number) {
　　len = len || 32;
　　var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';   
　　var maxPos = chars.length;
　　var pwd = '';
　　for (let i = 0; i < len; i++) {
    　　pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}